module.exports = __webpack_public_path__ + "img/lock-grey.177888f1.svg";